<template>
    <table class="table">
        <thead>
            <tr>
                <th style="min-width: 40px">币种</th>
                <th class="table-header-selected">
                    <select v-model="aBourseSelected" @change="bourseSelectEvent">
                        <option value="1">okex</option>
                        <option value="2">火币</option>
                    </select>
                    <select v-model="aTransactionTypeSelect" @change="transactionEvent" style="text-align: center;text-align-last: center">
                        <option v-for="(trade, index) in tradeTypeCalList('a')" :key="index" :value="trade">{{index}}</option>
                    </select>
                </th>
                <th class="table-header-selected">
                    <select v-model="bBourseSelected" @change="bourseSelectEvent">
                        <option value="1">okex</option>
                        <option value="2">火币</option>
                    </select>
                    <select v-model="bTransactionTypeSelect" @change="transactionEvent" style="text-align: center;text-align-last: center">
                        <option v-for="(trade, index) in tradeTypeCalList('b')" :key="index" :value="trade">{{index}}</option>
                    </select>
                </th>
                <th>{{totalTradeType[bTransactionTypeSelect]}} - {{totalTradeType[aTransactionTypeSelect]}}</th>
                <th class="th-last">{{totalTradeType[aTransactionTypeSelect]}} - {{totalTradeType[bTransactionTypeSelect]}}
                    <i title="删除" @click="closeTable()" class="fa fa-times-circle" aria-hidden="true"></i>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(table, index) in tableData" :key="index">
                <td class="table-currency-name">
                    <el-popover placement="right" width="600" trigger="click">
                        <div class="chart-content">
                            <div class="chart-title">
                                <h3>{{table.currency_type}}</h3>
                            </div>
                            <el-divider></el-divider>
                            <div class="chart-header">
                                <span :style="{'color': timeHightLight('1T')}" @click="timeChange('1T', index, $event)">1T</span>
                                <span :style="{'color': timeHightLight('30T')}" @click="timeChange('30T', index, $event)">30T</span>
                                <span :style="{'color': timeHightLight('1H')}" @click="timeChange('1H', index, $event)">1H</span><span :style="{'color': timeHightLight('4H')}" @click="timeChange('4H', index, $event)">4H</span>
                                <span :style="{'color': timeHightLight('1D')}" @click="timeChange('1D', index, $event)">1D</span><span :style="{'color': timeHightLight('1W')}" @click="timeChange('1W', index, $event)">1W</span>
                            </div>
                            <div class="chart">
                                <MarketChart ref="childChart"/>
                            </div>
                        </div>
                        <el-button class="chart-btn" slot="reference" @click="showChart(table.currency_type, index)">{{table.currency_type}}</el-button>
                    </el-popover>
                </td>
                <td style="padding: 8px 5px;text-align: center;" :style="{'color': sellPriceJudge(table.a_validity)}">{{table.a_buy}}</td>
                <td style="padding: 8px 5px;text-align: center;" :style="{'color': sellPriceJudge(table.b_validity)}">{{table.b_sell}}</td>
                <td class="td-min-width" style="text-align: right;min-width: 100px; max-width: 130px" :class="jurdgeColor(table.positive)">
                    <div class="td-box">
                        <div style="text-align: right">{{marketStr(table.positive)[1]}}</div>
                        <div>{{marketStr(table.positive)[2]}}</div>
                    </div>
                </td>
                <td class="td-min-width" style="text-align: right;min-width: 100px; max-width: 130px" :class="jurdgeColor(table.negative)">
                    <div class="td-box">
                        <div style="text-align: right">{{marketStr(table.negative)[1]}}</div>
                        <div>{{marketStr(table.negative)[2]}}</div>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions } from 'vuex'
import MarketChart from '@/views/market/MarketChart.vue'
import { post, get, put } from '@/api/index'

export default {
    data() {
        return {
            currencys: {},
            xData: [],
            Ydata: [],
            aData: [],
            bData: [],
            visible: false,
            timePointer: '1T',
            aType: '',
            bType: '',
            changeVisible: 0,
            aBourseSelected: 1,
            bBourseSelected: 1,
            paramList: [],
            aTransactionTypeSelect: 1,
            bTransactionTypeSelect: 2,
            huoBiTradeType: {'现货': 1, '本周': 2, '次周': 3, '季度': 4},
            okexTradeType: {'现货': 1, '本周': 2, '次周': 3, '季度': 4, '永续': 5, '次季': 10, 
            '本周U': 11, '次周U': 12, '本季U': 13, '次季U': 14},
            totalTradeType: {'1': '现货', '2': '本周', '3': '次周', '4': '季度', '5': '永续', '10': '次季',
            '11': '本周U', '12': '次周U', '13': '本季U', '14': '次季U'}
        }
    },
    inject: ['reload'],
    components: {
        MarketChart
    },
    mounted() {
        if (typeof this.marketTableList[this.tableParam-1] !== 'undefined') {
            this.aBourseSelected = this.marketTableList[this.tableParam-1][0];
            this.bBourseSelected = this.marketTableList[this.tableParam-1][1];
            this.aTransactionTypeSelect = this.marketTableList[this.tableParam-1][2];
            this.bTransactionTypeSelect = this.marketTableList[this.tableParam-1][3];
        }
    },
    props: ['tableData', 'tableParam'],
    computed:{
        ...mapState([
            'marketParam',
            'token',
            'tradeTypeList',
            'markets',
            'tableParamData',
            'tradeTypeObj',
            'marketData',
            'marketTableList',
            'zhToEn'
        ]),
    },
    methods: {
        ...mapActions([
            'changeMarketParam'
        ]),

        // 正负值 颜色判断
        jurdgeColor(data) {
            if (data.indexOf('/-') == -1) {// 没有出现负数
                return 'negativeColor'
            } else {
                return 'positiveColor'
            }
        },

        // aTransaction select 事件
        transactionEvent() {
            // this.changeMarketParam();
            this.paramList = [Number(this.aBourseSelected), Number(this.bBourseSelected), this.aTransactionTypeSelect, this.bTransactionTypeSelect]
            this.marketTableList[this.tableParam-1] = this.paramList;
            var param = {
                'token': this.token,
                'params': this.marketTableList
            }

            this.changeMarketParam(param);
        },

        // 删除表格
        closeTable() {
            this.marketTableList.splice(this.tableParam-1, 1);
            var param = {
                'token': this.token,
                'params': this.marketTableList
            }
            this.changeMarketParam(param);
        },

        // 图表展示
        showChart(currency, index) {
            var aTransactionType = this.aTransactionTypeSelect;
            var bTransactionType = this.bTransactionTypeSelect;
            // 生成交易类型数组
            var typeArray = Object.keys(this.tradeTypeObj);

            let a_type_name = this.totalTradeType[aTransactionType];
            let b_type_name = this.totalTradeType[bTransactionType];
            this.aType = this.usdtToB(a_type_name, 'aCurrencys', currency);
            this.bType = this.usdtToB(b_type_name, 'bCurrencys', currency);

            this.visible = true;
            let type_obj = {
                "aBourse": this.aBourseSelected,
                "bBourse": this.bBourseSelected
            }

            let zh_name = [a_type_name, b_type_name];
            this.$refs.childChart[index].sortData(this.currencys, this.aType, this.bType, this.timePointer, type_obj, zh_name);
        },

        // usdt本位 转换位 币本位
        usdtToB(name, key, currency) {
            let str_list = [];

            if (name.includes('U')) {
                str_list.push(currency.toLowerCase()+'_usdt')
                this.currencys[key] = str_list;
                return this.zhToEn[name.substr(0, name.length-1)];
            } else {
                let trade_type = this.zhToEn[name];

                if (trade_type == 'SS') {
                    str_list.push(currency.toLowerCase() + '_usdt')
                    this.currencys[key] = str_list;

                    return trade_type;
                } else {
                    str_list.push(currency.toLowerCase() + '_usd')
                    this.currencys[key] = str_list;

                    return trade_type;
                }
            }
        },


        // 切换事件节点
        timeChange(timeName, index, e) {
            this.timePointer = timeName;
            let type_obj = {
                "aBourse": this.aBourseSelected,
                "bBourse": this.bBourseSelected
            }
            this.$refs.childChart[index].sortData(this.currencys, this.aType, this.bType, this.timePointer, type_obj);

        },

        // 交易所选择触发事件
        bourseSelectEvent() {
            this.paramList = [Number(this.aBourseSelected), Number(this.bBourseSelected), this.aTransactionTypeSelect, this.bTransactionTypeSelect]
            this.marketTableList[this.tableParam-1] = this.paramList;
            var param = {
                'token': this.token,
                'params': this.marketTableList
            }

            this.changeMarketParam(param);
        },

        // 修改行情参数
        changeMarketParam(param) {
            var url = this.$baseUrl + '/market/put2';
            put(url, param).then(resp => {
                if (resp.code == 200) {

                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },

        // 时间切换高亮
        timeHightLight(time) {
            if (this.timePointer == time) return '#db5634';
        },

        // 数据字符串拼接
        marketStr(data) {
            var data_arr = data.split('/');
            var new_data = data_arr[0] + '｜' + data_arr[1] + '｜' + data_arr[2];
            return data_arr;
        },

        // 字体颜色判断
        sellPriceJudge(data) {
            if (data >= 1) {
                return '#ca5a5a';
            }
        },

        tradeTypeCalList(bourseType) {
            if (bourseType == 'a') {// a
                if (this.aBourseSelected == '1') {// okex
                    return this.okexTradeType;
                } else if (this.aBourseSelected == '2') {// huobi
                    return this.huoBiTradeType;
                }
            } else if (bourseType == 'b') {// b
                if (this.bBourseSelected == '1') {// okex
                    return this.okexTradeType;
                } else if (this.bBourseSelected == '2') {// huobi
                    return this.huoBiTradeType;
                }
            }
        }
    }
}
</script>

<style lang="scss">
    .el-popover{
        background-color: #262829;
        border: 0;
        box-shadow: 0 0 10px #656060;
    }
    .table{
        padding: 10px;
        border-collapse: collapse;
        width: 100%;
        thead{
            background-color: #262829;
            tr{
                th{
                    padding: 10px;
                    color: #A7A7A7;
                    font-size: 13px;
                    border: 1px solid #262829;
                    select{
                        padding: 2px;
                        border-radius: 3px;
                        background-color: #333333;
                        border-color: #333333;
                        color: #A7A7A7;
                        -webkit-appearance: none;
                        margin-left: 2px;
                        vertical-align: middle;
                        height: 25px !important;
                        option {
                            text-align: center;
                        }
                    }
                }
                .table-header-selected{
                    min-width: 85px;
                }
                .th-last{
                    position: relative;
                    i{
                        font-size: 15px;
                        position: absolute;
                        top: 0;
                        right: 0;
                    }
                    i:hover{
                        color: #fff;
                        cursor: pointer;
                    }
                }
                .table-header-th{
                    padding: 5px 10px;
                    .table-header-select{
                        text-align: left;
                        select{
                            margin-right: 10px;
                            padding: 5px;
                            vertical-align: middle;                  
                            -webkit-appearance: none;
                        }
                    }
                    
                }
            }
        }
        tbody{
            background-color: #2A2D2E;
            tr{
                td{
                    padding: 8px 14px;
                    color: #A7A7A7;
                    font-size: 13px;
                    border: 1px solid #383737;
                    // width: 100%;
                    .chart-btn{
                        font-size: 13px;
                    }
                }
                .td-min-width{
                    padding: 8px 0;
                    .td-box{
                        display: flex;
                        div{
                            flex: 1;
                            text-align: center;
                        }
                    }
                }
                .table-currency-name{
                    width: 30px;
                    .el-divider{
                        margin: 5px 0;
                    }
                    span{
                        .el-button{
                            background-color: #2b2b2b;
                            border-color: #2b2b2b;
                            padding: 0;
                            color: #A7A7A7;
                        }
                    }
                }
                .table-currency-name:hover{
                    cursor: pointer;
                }
            }
            
            tr:hover{
                background-color: #262829;
            }
        }

        .positiveColor{
            color: #1AB394;
            min-width: 110px;
        }

        .negativeColor{
            color: #F8AC59;
            min-width: 110px;
        }
    }
    .el-popover{
        .el-divider{
            margin: 12px 0;
            background-color: #6f6f6f;
        }
        .chart-header{
            span{
                font-size: 12px;
                margin-right: 10px;
            }
            span:hover{
                cursor: pointer;
            }
        }
    }

</style>
